import { all, takeLatest, put } from 'redux-saga/effects';
import { matchesType } from '../helper';
import { businessModule as actions } from '../../../actions';

function* getId(): any {
  try {
    const searchParams = new URLSearchParams(window.location.search);
    const businessModule = searchParams.get('businessModule') || 'standard';
    yield put(actions.receiveId(businessModule));
  } catch (e) {}
}

function* businessModule(): any {
  yield all([takeLatest(matchesType(actions.getId), getId)]);
}

export { businessModule };
